import React, { useState } from 'react';
import {
    FormControl, FormGroup, FormControlLabel, Checkbox, Menu, Button,
    ListItemText, ListItemIcon, MenuItem, Box, Paper, Stack, Typography
} from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';

interface CustomTypeFilterProps {
    valueOptions: string[];
    setFilterType: any;
}

export const ProjectDataGridFilterType: React.FC<CustomTypeFilterProps> = ({ valueOptions, setFilterType }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedType, setSelectedType] = useState<string[]>([]);

    const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const closeMenu = () => {
        setAnchorEl(null);
    };

    const handleApplyFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setFilterType(selectedType);
        closeMenu();
    };

    const handleSelectAllFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setSelectedType([...valueOptions, '']);
        setFilterType([...valueOptions, '']);
    };

    const handleClearFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setSelectedType([]);
        setFilterType([]);
    };

    const handleTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.stopPropagation();
        const { name, checked } = event.target;
        const updatedType = [...selectedType];
        if (checked) {
            updatedType.push(name);
        } else {
            const index = updatedType.indexOf(name);
            if (index !== -1) {
                updatedType.splice(index, 1);
            }
        }
        setSelectedType(updatedType);
        setFilterType(updatedType);
    };

    return (
        <Box>
            <Button
                variant={selectedType.length >= valueOptions.length || selectedType.length == 0 ? 'text' : 'contained'}
                onClick={openMenu}
                size='small'
                color={selectedType.length >= valueOptions.length || selectedType.length == 0 ? 'inherit' : 'primary'}
                sx={{ textTransform: 'none', width: '100px' }}
            >
                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-evenly'} width={'100%'}>
                    <Typography variant='body2'>
                        Type
                    </Typography>
                    <TuneIcon fontSize='small' />
                </Stack>
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={closeMenu}
            >
                <Stack
                    direction='column'
                    sx={{ m: 1, my: 0 }}
                    spacing={1}
                >
                    <FormControl component='fieldset' sx={{ m: 0, p: 0, maxHeight: '600px', overflow: 'auto' }}>
                        <FormGroup>
                            {valueOptions.map((type) => (
                                <FormControlLabel
                                    key={type}
                                    control={
                                        <Checkbox
                                            name={type}
                                            checked={selectedType.includes(type)}
                                            onChange={handleTypeChange}
                                        />
                                    }
                                    label={type ? type : 'Blank'}
                                />
                            ))}
                        </FormGroup>
                    </FormControl>
                    <Stack direction={'column'} spacing={1}>
                        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} spacing={1}>
                            <Button
                                onClick={(e) => handleSelectAllFilter(e)}
                                variant='contained'
                                fullWidth
                            >
                                All
                            </Button>
                            <Button
                                onClick={(e) => handleClearFilter(e)}
                                variant='contained'
                                fullWidth
                            >
                                Clear
                            </Button>
                        </Stack>
                        {/* <Button
                            onClick={(e) => handleApplyFilter(e)}
                            variant='contained'
                        >
                            Apply
                        </Button> */}
                    </Stack>
                </Stack>
            </Menu>
        </Box>
    );
};
